const API_NAME = process.env.REACT_APP_API_NAME
  ? `/${process.env.REACT_APP_API_NAME}`
  : "";

export const apiQuery = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_IP}${API_NAME}`;
